export enum Colors {
  BLACK = "#000000",
  WHITE = "#FFFFFF",
  DIM_RED = "#D36978",
  RED = "#FF0000",
  LIME = "#00FF00",
  SKIN = "#E6E6E6",
  WHITE_SKIN = "#F3F3F3",
  SKIN_UPGRADE_BUTTON = "#FF8181",
  GREY = "#1C1C1C66",
  LIGHT_GRAY = "#d3d3d3",
  DARK_GRAY = "#A9A9A9",
  DARKER_GRAY = "#8E8EA0",
  DARKER_DARKER_GRAY = "#888888",
  STONE_GRAY = "#A0AAB1",
  LIGHT_GRAY_BG_F6F8FA = "#F6F8FA",
  PINK_FIR_TREE = "#1C1C1C1A",
  LAZO_PURPLE = "#A16DFC",
  LIGHT_GRAY2 = "#DADADA",
  ULTRA_LIGHT_GRAY = "#888888",
  ALMOST_WHITE = "#F9F9F9",
  LAZO_PURPLE2 = "#D5B4FF",
  DARK_LAZO_PURPLE = "#50158C",
  DARK_PURPLE = "#281B4B",
  DARK_PURPLE_30013F = "#30013F",
  LAZO_LIGHT_PURPLE = "#F3EEFF",
  LAZO_DARK_BLUE = "#281B4B",
  LAZO_BLUE = "#3451E7",
  LAZO_PURPLE_TEXT = "#667EEA",
  LAZO_LIGHT_PURPLE_TEXT = "#9685F7",
  AMATIST_PURPLE = "#A184FF",
  ELEGANT_BLACK = "#1C1C1C",
  PURPLE = "#A184FF",
  LIGHT_GRAY_F3F3F3 = "#F3F3F3",
  LIGHT_GRAY_8E8EA0 = "#8E8EA0",
  LIGHT_GRAY_CDCDCD = "#CDCDCD",
  LIGHT_GRAY_DDDDDD = "#DDDDDD",
  LIGHT_BLUE = "#B1BFFF",
  STONE_OCEAN_BLUE = "#6A71D8",
  INDIGO = "#95A4FC",
  PINK_F18DE1 = "#F18DE1",
  YELLOW_DESATURATED_FFF4BC = "#FFF4BC",
  YELLOW_F1D95A = "#F1D95A",
  ACCENT_GREY_D7D7DA = "#D7D7DA",
  LIGHT_GRAY_8A8E93 = "#8A8E93",
  LIGHT_GRAY_656970 = "#656970",
  LIGHT_GREEN_CAEA2F = "#CAEA2F",
  LIGHT_GREEN_DESATURATED_FCFFEC = "#FCFFEC",
  BLUE_9AA9F9 = "#9AA9F9",
  LIGHT_GRAY_DEDEE1 = "#DEDEE1",
  BUTTON_PURPLE = "#A16DFC",
  BUTTON_HOVER_PURPLE = "#8E53F4",
  LIGHT_GRAY_4a4b4e = "#4a4b4e",
  LIGHT_GRAY_BFC2C6 = "#BFC2C6",
  DARK_GREY_3E3E3E = "#3E3E3E",
  BUTTON_SECONDARY_PURPLE = "#F5EFFF",
  BUTTON_SECONDARY_HOVER_PURPLE = "#E9DDFF",
  BUTTON_GRAY = "#EBEDEF",
  LIGHT_GRAY_F4F4F4 = "#F4F4F4",
  HEART_RED = "#EF4444",
  ACCENT_RED_DESATURATED_FFEAEA = "#FFEAEA",
  BLACK_151517 = "#151517",
  LAZO_PURPLE_DCAFFF = "#DCAFFF",
  STROKE_DARK_GRAY = "#ABABAF",
  ACCENT_GREEN_01A902 = "#01A902",
  ACCENT_GREEN_DESATURATED_E9FFE9 = "#E9FFE9",
  ACCENT_F1F3FF = "#F1F3FF",
  BLUE_4763F4 = "#4763F4",
  ORANGE_FF9A3D = "#FF9A3D",
  GREEN_01A902 = "#01A902",
  LIGHT_GRAY_ECEFF1 = "#ECEFF1",
  LIGHT_GRAY_F7F8FA = "#F7F8FA",
  ACCENT_ORANGE_LIGHT = "#FFFBE7",
  ACCENT_ORANGE = "#F1D95A",
  LIGHT_GRAY_FDFDFD = "#FDFDFD",
  A6A6A6_GREY = "#A6A6A6",
  STROKE_FOR_HOVERS_6C6C77 = "#6C6C77",
  PURPLE_D196FF = "#D196FF",
  LIGHT_GRAY_7A7E82 = "#7A7E82",
  F7F7F8_GRAY = "#F7F7F8",
  PURPLE_AA5FEF = "#AA5FEF",
  PURPLE_8541FC = "#8541FC",
  PURPLE_8B43FF = "#8B43FF",
  BUTTON_GRAY_HOVER_E2E6E9 = "#E2E6E9",
  ACCENT_BLUE_DESATURATED_CED5FD = "#CED5FD",
  INPUTS_BACKGROUND_ON_ERROR = "#FCF1F1",
  BLACK_2 = "#222020",
  BLACK_27282C = "#27282C",
  LIGHT_GREEN_DESATURATED_EFFCB4 = "#EFFCB4",
  LIGHT_GRAY_EBEBEB = "#EBEBEB",
  LIGHT_GRAY_747775 = "#747775",
  LIGHT_GRAY_65696C = "#65696C",
  LIGHT_PURPLE = "#A146E9",
  LIGHT_DISABLED_PURPLE = "#c7a7fc",
  GREY_65696C = "#65696C",
  GRAY_898D92 = "#898D92",
  PURPLE_6750A4 = "#6750A4",
  LIGHT_PURPLE_F6F3FF = "#F6F3FF",
  // Comment user type colors
  CLIENT_AVATAR_BG = "#E3F2FD",
  CLIENT_AVATAR_TEXT = "#1565C0",
  CLIENT_BADGE_BG = "#E3F2FD",
  CLIENT_BADGE_TEXT = "#1565C0",
  CLIENT_BADGE_BORDER = "#90CAF9",
  LAZO_AVATAR_BG = "#F3E5F5",
  LAZO_AVATAR_TEXT = "#6A1B9A",
  LAZO_BADGE_BG = "#F3E5F5",
  LAZO_BADGE_TEXT = "#6A1B9A",
  LAZO_BADGE_BORDER = "#CE93D8",
  LIGHT_GRAY_F5F5F5 = "#F5f5f5",
  LIGHT_GRAY_F0F2F5 = "#F0F2F5",

  // ── Borders & surfaces (neutral) ─────────────────────────────────────────
  BORDER_SUBTLE = "#E0E0E8",
  BORDER_DASHED = "#D8D8E0",
  DIVIDER_SUBTLE = "#E8E8EC",
  SURFACE_MUTED = "#FAFAFA",
  SURFACE_HOVER = "#F5F5F8",
  SURFACE_CHIP_DEFAULT = "#F0F0F0",
  SURFACE_PREVIEW_BG = "#F4F4F7",
  SURFACE_SUBTLE_BOX = "#F7F7FA",
  ICON_MUTED = "#B0B0B8",
  AVATAR_DEFAULT_BG = "#ECECEC",

  // ── Status: error ─────────────────────────────────────────────────────────
  STATUS_ERROR_BORDER = "#FFCDD2",
  STATUS_ERROR_SURFACE = "#FFF5F5",
  STATUS_ERROR_ICON = "#D32F2F",
  STATUS_ERROR_TEXT = "#C62828",

  // ── Status: success ───────────────────────────────────────────────────────
  STATUS_SUCCESS_BORDER = "#C8E6C9",
  STATUS_SUCCESS_SURFACE = "#F1F8F1",
  STATUS_SUCCESS_ICON = "#388E3C",
  STATUS_SUCCESS_TEXT = "#2E7D32",

  // ── Status: warning ───────────────────────────────────────────────────────
  STATUS_WARNING_BORDER = "#FFE082",
  STATUS_WARNING_SURFACE = "#FFFDE7",
  STATUS_WARNING_ICON = "#F57C00",
  STATUS_WARNING_TEXT = "#E65100",

  // ── File type icons ────────────────────────────────────────────────────────
  ICON_PDF_RED = "#E53935",
  ICON_IMAGE_PURPLE = "#6A1B9A",

  // ── Drop zone ─────────────────────────────────────────────────────────────
  SURFACE_DROPZONE_GRADIENT_END = "#F8F6FF",

  // ── Interactive states ─────────────────────────────────────────────────────
  BORDER_CANCEL_HOVER = "#C8C8D0",
  SURFACE_ERROR_HOVER = "#FFD6D6",

  // ── Tool cards ────────────────────────────────────────────────────────────
  BLUE_2196F3 = "#2196F3",
  LAZO_PURPLE_GRADIENT_END = "#C084FC",

  // ── Status: warning/overdue ──────────────────────────────────────────────
  STATUS_OVERDUE_TEXT = "#EF5350",
  STATUS_OVERDUE_SURFACE = "#FFF5F5",

  // ── Status: action required ──────────────────────────────────────────────
  STATUS_ACTION_REQUIRED_TEXT = "#E8873F",
  STATUS_ACTION_REQUIRED_SURFACE = "#FFF5EB",
  STATUS_ACTION_REQUIRED_BORDER = "#FCCFA0",

  // ── Status: completed ────────────────────────────────────────────────────
  STATUS_COMPLETED_TEXT = "#4CAF50",
  STATUS_COMPLETED_SURFACE = "#F0F9F0",

  // ── Status: pending ──────────────────────────────────────────────────────
  STATUS_PENDING_TEXT = "#F57F17",
  STATUS_PENDING_SURFACE = "#FFFDE7",

  // ── Status: waiting for review ───────────────────────────────────────────
  STATUS_REVIEW_TEXT = "#5C6BC0",
  STATUS_REVIEW_SURFACE = "#EEF0FB",

  // ── Text ─────────────────────────────────────────────────────────────────
  TEXT_SECONDARY = "#6B7280",
  TEXT_TERTIARY = "#9CA3AF",

  // ── Module chips ─────────────────────────────────────────────────────────
  MODULE_CHIP_BG = "#EDE7F6",
  MODULE_CHIP_TEXT = "#5E35B1",

  // ── My Companies overview page ───────────────────────────────────────────
  MY_COMPANIES_PAGE_BG = "#F4F0FB",
  MY_COMPANIES_PRIMARY_BORDER = "#A16DFC",
  MY_COMPANIES_CURRENT_TAB_BG = "#6C3FDB",
  MY_COMPANIES_SOFT_PANEL_BG = "#F7F7FA",
  MY_COMPANIES_CURRENT_CARD_SHADOW = "rgba(125, 74, 235, 0.08)",
  MY_COMPANIES_TOP_BANNER_ACTIONS_BG = "#492A15",
  MY_COMPANIES_TOP_BANNER_ACTIONS_BORDER = "#D9740B",
  MY_COMPANIES_TOP_BANNER_ACTIONS_TEXT = "#D9740B",
  MY_COMPANIES_TOP_BANNER_UNREAD_BG = "#32254A",
  MY_COMPANIES_TOP_BANNER_UNREAD_BORDER = "#9F7EF5",
  MY_COMPANIES_TOP_BANNER_UNREAD_TEXT = "#9F7EF5",
  MY_COMPANIES_COMMENT_PILL_BG = "#FEF3C7",
  MY_COMPANIES_COMMENT_PILL_BORDER = "#FCD34D",
  MY_COMPANIES_COMMENT_PILL_TEXT = "#92400E",
  MY_COMPANIES_ACTION_PILL_BG = "#FFEDD4",
  MY_COMPANIES_ACTION_PILL_BORDER = "#F6530C",
  MY_COMPANIES_ACTION_PILL_TEXT = "#F6530C",
  MY_COMPANIES_IN_PROGRESS_PILL_BG = "#F3EBFF",
  MY_COMPANIES_IN_PROGRESS_PILL_BORDER = "#D8C3FB",
  MY_COMPANIES_IN_PROGRESS_PILL_TEXT = "#6B21A8",
  MY_COMPANIES_SERVICE_ROW_ACTION_BG = "#FFF7ED",
  MY_COMPANIES_SERVICE_ROW_ACTION_BORDER = "#FDBA74",
  MY_COMPANIES_SERVICE_ROW_BORDER = "#E5E7EB",
  MY_COMPANIES_NOTIFICATION_ICON = "#F59E0B",

  // ── Notes feature ────────────────────────────────────────────────────────
  NOTES_SCROLLBAR_THUMB = "rgba(161, 109, 252, 0.4)",
  NOTES_SCROLLBAR_THUMB_HOVER = "rgba(161, 109, 252, 0.65)",
  NOTES_LIGHTBOX_BUTTON_BG = "rgba(0, 0, 0, 0.45)",
  NOTES_LIGHTBOX_BUTTON_BG_HOVER = "rgba(0, 0, 0, 0.65)",
  NOTES_LIGHTBOX_TEXT_SHADOW = "rgba(0, 0, 0, 0.5)",
  NOTES_IMAGE_RESIZE_HANDLE = "rgba(161, 109, 252, 0.45)",
  NOTES_IMAGE_RESIZE_HANDLE_HOVER = "rgba(161, 109, 252, 0.75)",
}
